import { useMutation } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../CommonUtils/httpBodyOptions';

export const deleteInstitution = async ({ clientId, itemId }) =>
  authFetch('/Consumer/HeldAwayInstitutions/DeleteLink', {
    method: 'DELETE',
    ...httpBodyOptions({ clientId, itemId }),
  });

export const useDeleteInstitutionMutation = () => {
  return useMutation(deleteInstitution);
};
